// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QqCircleFilledSvg from "@fishx/icons-svg/es/asn/QqCircleFilled";
import FishxIcon from '../components/FishxIcon';

var QqCircleFilled = function QqCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: QqCircleFilledSvg
  }));
};

QqCircleFilled.displayName = 'QqCircleFilled';
export default React.forwardRef(QqCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/QqCircleFilled.js
// module id = 3944
// module chunks = 0